var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "sw--position-bottom\n              sw--position-left\n              sw--position-right\n              sw--position-fixed\n              sw--padding-hor-4\n              sw--padding-vert-2\n              sw-dms--bg-white\n              sw--z-index-10\n              sw-grid-flex\n              sw--border-grey-64-1\n              sw-grid-flex--align-center",
      class: _vm.showSaveBtn
        ? "sw-grid-flex--justify-flex-end"
        : "sw-grid-flex--justify-center"
    },
    [
      _vm.showSavedMessage
        ? _c(
            "div",
            {
              staticClass:
                "sw--font-size-14 sw--margin-right-3 sw-grid-flex sw-grid-flex--align-center"
            },
            [
              _c("span", {
                staticClass:
                  "icon-checkmark-circled sw--text-green sw--font-size-18 sw--padding-hor-2"
              }),
              _vm._v("This section has been saved\n  ")
            ]
          )
        : _vm.hasMissingInfo
        ? _c(
            "div",
            {
              staticClass:
                "sw--font-size-14 sw--margin-right-3 sw-grid-flex sw-grid-flex--dir-column"
            },
            [
              _vm._v(
                "\n    You can only save this section after saving:\n    "
              ),
              _vm._l(_vm.missingInfo, function(info) {
                return _c(
                  "span",
                  {
                    staticClass: "sw-dms--color-red-error sw--font-weight-bold"
                  },
                  [_vm._v("● " + _vm._s(info))]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddNewBtn && _vm.showSaveBtn
        ? _c(
            "button",
            {
              staticClass:
                "sw-dms-button sw-dms-button--big sw--margin-right-3",
              on: {
                click: function($event) {
                  return _vm.$emit("add-new")
                }
              }
            },
            [_vm._v("\n    Add New\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCancelBtn && !_vm.showSavedMessage
        ? _c(
            "button",
            {
              staticClass:
                "sw-dms-button sw-dms-button--big sw--margin-right-3",
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [_vm._v("\n    Cancel\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSaveBtn
        ? _c(
            "button",
            {
              staticClass:
                "sw-dms-button sw-dms-button--red sw-dms-button--big",
              on: {
                click: function($event) {
                  return _vm.$emit("saved")
                }
              }
            },
            [_vm._v("Save\n  ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }